import ApiConfig from '@api';
import ChannelsClassic from '@components/atoms/icons/channelsClassic';
import ChannelsIcon from '@components/atoms/icons/channels';
import ChannelViewContainer from '@components/elements/choice/channelViewContainer';
import ChannelsViewContainer from '@components/atoms/container/channelsViewContainer';
import FlavourConfig from '@shared/config/flavours';
import Focus from '@shared/types/enums/focus';
import List from '../../sections/list/list';
import Pages from '@pages';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import { userSelector } from '@shared/store/slices/user.slice';

type Props = {
  onSelectEnter?: (typeView: string) => void;
};

export default function ChoiceContainer({ onSelectEnter }: Props) {
  const { carrierId } = useAppSelector(userSelector);

  const views = [
    {
      icon: ChannelsClassic,
      textKey: TranslationManager.get('PAGES.CHANNELS_CHOICE.CLASSIC_VIEW'),
      typeView: Pages.CLASSIC_CHANNEL,
      image: ApiConfig.urls.images.channelsClassic.replace(
        '{OPERATOR_ID}',
        carrierId || FlavourConfig.carrierId
      ),
    },
    {
      icon: ChannelsIcon,
      textKey: TranslationManager.get('PAGES.CHANNELS_CHOICE.DIAL_VIEW'),
      typeView: Pages.CHANNELS_MAIN,
      image: ApiConfig.urls.images.channelsDial.replace(
        '{OPERATOR_ID}',
        carrierId || FlavourConfig.carrierId
      ),
    },
  ];

  const dispatch = useDispatch();

  const onEnter = useCallback(
    (index: number) => {
      if (onSelectEnter) {
        onSelectEnter(index);
      }
    },
    [onSelectEnter]
  );

  const outOfBounds = (focus: string | number, key?: string) => {
    if (key === 'LEFT') {
      dispatch(setFocus(Focus.MENU));
    }
  };

  return (
    <ChannelsViewContainer>
      <List focus={Focus.CHANNELS_CHOICE} outOfBounds={outOfBounds}>
        {views.map((view, index) => (
          <ChannelViewContainer
            key={index}
            index={index}
            text={view.textKey}
            Icon={view.icon}
            image={view.image}
            action={() => {
              onEnter(index);
            }}
          />
        ))}
      </List>
    </ChannelsViewContainer>
  );
}
